import React from "react";
import ReasonSummary from "./ReasonSummary";

type ReasonSummariesItem = {
  summary: string;
  text: string;
};

const ReasonSummaries = () => {
  const ReasonSummaries: ReasonSummariesItem[] = [
    {
      summary: "梱包",
      text: "①段ボールが国内配送中に破損した場合は<span class='text-red-500'>新しいものに移し替えます</span><br>②段ボール内の緩衝材を<span class='text-red-500'>追加します</span>　※酒の場合はエアパッキンに詰め替えます<br>③外側を<span class='text-red-500'>緩衝材で巻きます</span>",
    },
    {
      summary: "問い合わせ",
      text: "未着や万一破損した場合の<span class='text-red-500'>多言語による問い合わせにJ&J Tax Freeが対応します</span><br>※問い合わせ先はお客様宛に送るサンキューメールに記載しています<br>※商品配送後にお客様へ追跡番号と配送会社の追跡用サイトのURLを送ります",
    },
    {
      summary: "複数の配送会社と契約しています",
      text: "商品内容や配送状況に応じて日本郵便（EMS）・DHL両方の配送が可能です<span class='text-red-500'><br>急なトラブルで引き受け不可になった場合も速やかに他の配送会社でお届けします</span>",
    },
    {
      summary: "運送保険対応",
      text: "ご要望に応じて 運送保険（有償）もお申込みが可能。高価商品も<span class='text-red-500'>安心して送ることができます</span>",
    },
    {
      summary: "手厚いサポート",
      text: "店舗様専用の<span class='text-red-500'>24時間365日の無償サポートデスク</span>を完備",
    },
    {
      summary: "個人情報",
      text: "配送先住所等の個人情報データはJ&J Tax Freeに届くため<span class='text-red-500'>店舗様で管理不要</span>",
    },
  ];
  return (
    <div>
      {ReasonSummaries.map(
        (reasonSummary: ReasonSummariesItem, index: number) => {
        return (
          <ReasonSummary
            key={reasonSummary.summary}
            number={index + 1}
            summary={reasonSummary.summary}
            text={reasonSummary.text}
          />
        );
        }
      )}
    </div>
  );
};

export default ReasonSummaries;
